import {
  REPORT_CONSUMPTION_SHOTS_FAILURE,
  REPORT_CONSUMPTION_SHOTS_REQUEST,
  REPORT_CONSUMPTION_SHOTS_SUCCESS,
  REPORT_TRANSACTIONS_REQUEST,
  REPORT_TRANSACTIONS_SUCCESS,
  REPORT_TRANSACTIONS_FAILURE,
  REPORT_WHOLESALER_REPORT_REQUEST,
  REPORT_WHOLESALER_REPORT_SUCCESS,
  REPORT_WHOLESALER_REPORT_FAILURE,
  REPORT_TRANSACTIONS_SEARCH_REQUEST,
  REPORT_TRANSACTIONS_SEARCH_SUCCESS,
  REPORT_TRANSACTIONS_SEARCH_FAILURE,
  REPORT_CONSUMPTION_SHOTS_SEARCH_REQUEST,
  REPORT_CONSUMPTION_SHOTS_SEARCH_SUCCESS,
  REPORT_CONSUMPTION_SHOTS_SEARCH_FAILURE,
  REPORT_WHOLESALER_REPORT_SEARCH_REQUEST,
  REPORT_WHOLESALER_REPORT_SEARCH_SUCCESS,
  REPORT_WHOLESALER_REPORT_SEARCH_FAILURE,
  WHOLESALER_REPORT_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_DATE_SEARCH_FAILURE,
  REPORT_WHOLESALER_MONTH_REPORT_REQUEST,
  REPORT_WHOLESALER_MONTH_REPORT_SUCCESS,
  REPORT_WHOLESALER_MONTH_REPORT_FAILURE,
  REPORT_WHOLESALER_WEEK_REPORT_REQUEST,
  REPORT_WHOLESALER_WEEK_REPORT_SUCCESS,
  REPORT_WHOLESALER_WEEK_REPORT_FAILURE,
  WHOLESALER_REPORT_MONTH_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_MONTH_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_MONTH_DATE_SEARCH_FAILURE,
  WHOLESALER_REPORT_WEEK_DATE_SEARCH_REQUEST,
  WHOLESALER_REPORT_WEEK_DATE_SEARCH_SUCCESS,
  WHOLESALER_REPORT_WEEK_DATE_SEARCH_FAILURE,
} from "./ReportTypes";

// View All Products Actions
export const consumptionViewAllRequest = (
  wholesalerId,
  pageNo,
  search_key
) => ({
  type: REPORT_CONSUMPTION_SHOTS_REQUEST,
  payload: wholesalerId,
  pageNo,
  search_key,
});

export const consumptionViewAllSuccess = (products) => ({
  type: REPORT_CONSUMPTION_SHOTS_SUCCESS,
  payload: products,
});

export const consumptionViewAllFailure = (error) => ({
  type: REPORT_CONSUMPTION_SHOTS_FAILURE,
  payload: error,
});

// Transactions Actions
export const transactionsRequest = (pageNo) => ({
  type: REPORT_TRANSACTIONS_REQUEST,
  payload: pageNo,
});

export const transactionsSuccess = (transactions) => ({
  type: REPORT_TRANSACTIONS_SUCCESS,
  payload: transactions,
});

export const transactionsFailure = (error) => ({
  type: REPORT_TRANSACTIONS_FAILURE,
  payload: error,
});

// Wholesaler Month Report Actions
export const wholesalerMonthReportRequest = (queryObj) => ({
  type: REPORT_WHOLESALER_MONTH_REPORT_REQUEST,
  payload: queryObj,
});

export const wholesalerMonthReportSuccess = (report) => ({
  type: REPORT_WHOLESALER_MONTH_REPORT_SUCCESS,
  payload: report,
});

export const wholesalerMonthReportFailure = (error) => ({
  type: REPORT_WHOLESALER_MONTH_REPORT_FAILURE,
  payload: error,
});

// Wholesaler Week Report Actions
export const wholesalerWeekReportRequest = (queryObj) => ({
  type: REPORT_WHOLESALER_WEEK_REPORT_REQUEST,
  payload: queryObj,
});

export const wholesalerWeekReportSuccess = (report) => ({
  type: REPORT_WHOLESALER_WEEK_REPORT_SUCCESS,
  payload: report,
});

export const wholesalerWeekReportFailure = (error) => ({
  type: REPORT_WHOLESALER_WEEK_REPORT_FAILURE,
  payload: error,
});

// Wholesaler Day Report Actions
export const wholesalerReportRequest = (queryObj) => ({
  type: REPORT_WHOLESALER_REPORT_REQUEST,
  payload: queryObj,
});

export const wholesalerReportSuccess = (report) => ({
  type: REPORT_WHOLESALER_REPORT_SUCCESS,
  payload: report,
});

export const wholesalerReportFailure = (error) => ({
  type: REPORT_WHOLESALER_REPORT_FAILURE,
  payload: error,
});

//Transactions Search
export const transactionsSearchRequest = (query) => ({
  type: REPORT_TRANSACTIONS_SEARCH_REQUEST,
  payload: query,
});

export const transactionsSearchSuccess = (results) => ({
  type: REPORT_TRANSACTIONS_SEARCH_SUCCESS,
  payload: results,
});

export const transactionsSearchFailure = (error) => ({
  type: REPORT_TRANSACTIONS_SEARCH_FAILURE,
  payload: error,
});

//Consumption Shots Search
export const consumptionShotsSearchRequest = (query) => ({
  type: REPORT_CONSUMPTION_SHOTS_SEARCH_REQUEST,
  payload: query,
});

export const consumptionShotsSearchSuccess = (results) => ({
  type: REPORT_CONSUMPTION_SHOTS_SEARCH_SUCCESS,
  payload: results,
});

export const consumptionShotsSearchFailure = (error) => ({
  type: REPORT_CONSUMPTION_SHOTS_SEARCH_FAILURE,
  payload: error,
});

//Wholesaler Month Date Search
export const wholesalerMonthReportDateSearchRequest = (queryObj) => ({
  type: WHOLESALER_REPORT_MONTH_DATE_SEARCH_REQUEST,
  payload: queryObj,
});

export const wholesalerMonthReportDateSearchSuccess = (results) => ({
  type: WHOLESALER_REPORT_MONTH_DATE_SEARCH_SUCCESS,
  payload: results,
});

export const wholesalerMonthReportDateSearchFailure = (error) => ({
  type: WHOLESALER_REPORT_MONTH_DATE_SEARCH_FAILURE,
  payload: error,
});

//Wholesaler Week Date Search
export const wholesalerWeekReportDateSearchRequest = (queryObj) => ({
  type: WHOLESALER_REPORT_WEEK_DATE_SEARCH_REQUEST,
  payload: queryObj,
});

export const wholesalerWeekReportDateSearchSuccess = (results) => ({
  type: WHOLESALER_REPORT_WEEK_DATE_SEARCH_SUCCESS,
  payload: results,
});

export const wholesalerWeekReportDateSearchFailure = (error) => ({
  type: WHOLESALER_REPORT_WEEK_DATE_SEARCH_FAILURE,
  payload: error,
});

//Wholesaler Day Date Search
export const wholesalerReportDateSearchRequest = (queryObj) => ({
  type: WHOLESALER_REPORT_DATE_SEARCH_REQUEST,
  payload: queryObj,
});

export const wholesalerReportDateSearchSuccess = (results) => ({
  type: WHOLESALER_REPORT_DATE_SEARCH_SUCCESS,
  payload: results,
});

export const wholesalerReportDateSearchFailure = (error) => ({
  type: WHOLESALER_REPORT_DATE_SEARCH_FAILURE,
  payload: error,
});

//Wholesaler Search
export const wholesalerReportSearchRequest = (query) => ({
  type: REPORT_WHOLESALER_REPORT_SEARCH_REQUEST,
  payload: query,
});

export const wholesalerReportSearchSuccess = (results) => ({
  type: REPORT_WHOLESALER_REPORT_SEARCH_SUCCESS,
  payload: results,
});

export const wholesalerReportSearchFailure = (error) => ({
  type: REPORT_WHOLESALER_REPORT_SEARCH_FAILURE,
  payload: error,
});
